import { render, staticRenderFns } from "./AnonymisationSection.vue?vue&type=template&id=5e47bc62&"
import script from "./AnonymisationSection.vue?vue&type=script&lang=ts&"
export * from "./AnonymisationSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports